import styled, { css, keyframes } from 'styled-components';

const createSpinCycleAnimation = ({
    growTo,
    shrinkTo,
    highlightColor,
    baseColor,
}: {
    growTo: number;
    shrinkTo: number;
    highlightColor: string;
    baseColor: string;
}) => keyframes`
  from {
    fill: ${highlightColor};
    transform: scale(${growTo});
  }
  to {
    fill: ${baseColor};
    transform: scale(${shrinkTo});
  }
`;

const SpinCycle = styled.div<{ black: boolean }>`
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    overflow: visible;
    > svg {
        display: block;
        overflow: visible;
        > * {
            transform: translate3d(0, 0, 0);
            transform-origin: center;
            animation-iteration-count: infinite;
        }
    }
`;

export const Spinner = styled(SpinCycle)<{ black: boolean }>`
    margin: 12px;
    width: 25px;
    height: 25px;

    > svg {
        width: 25px;
        height: 25px;

        > * {
            fill: ${({ black }) => (black ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)')};
            animation-name: ${({ black }) =>
                black
                    ? createSpinCycleAnimation({
                          shrinkTo: 1,
                          growTo: 1,
                          highlightColor: '#000',
                          baseColor: 'rgba(0, 0, 0, 0.1)',
                      })
                    : createSpinCycleAnimation({
                          shrinkTo: 1,
                          growTo: 1,
                          highlightColor: '#fff',
                          baseColor: 'rgba(255, 255, 255, 0.1)',
                      })};

            animation-duration: ${7 * 0.1}s;

            ${Array.from(
                { length: 7 },
                (_, i) => css`
                    &:nth-of-type(${i + 1}) {
                        animation-delay: ${i * 0.1}s;
                    }
                `,
            )}
        }
    }
`;
